export default function usePersonChangesTable() {
  function getChangeMessage(rows) {
    const changeMessage = []
    const changeMessageItem = rows.find((item) => item.key === 'CHANGE_MESSAGE')

    changeMessageItem && changeMessage.push(changeMessageItem)

    return changeMessage
  }

  function getContributorSubmitterIds(rows) {
    const sortedContributorSubmitter = []
    const contributorIdItem = rows.find((item) => item.key === 'CONTRIBUTOR_ID')
    const submitterIdItem = rows.find((item) => item.key === 'SUBMITTER_ID')

    contributorIdItem && sortedContributorSubmitter.push(contributorIdItem)
    submitterIdItem && sortedContributorSubmitter.push(submitterIdItem)

    return sortedContributorSubmitter
  }

  function getFirstItem(rows) {
    const firstItem = rows.find((row) => row.key === 'TYPE' || row.key === 'CONCLUSION_TYPE' || row.key === 'SPACE_ID')
    if (firstItem) {
      return [firstItem]
    }
    return []
  }

  function getAllOtherItems(rows) {
    return rows.filter(
      (row) =>
        row.key !== 'TYPE' &&
        row.key !== 'CONCLUSION_TYPE' &&
        row.key !== 'SPACE_ID' &&
        row.key !== 'CONTRIBUTOR_ID' &&
        row.key !== 'SUBMITTER_ID' &&
        row.key !== 'CHANGE_MESSAGE'
    )
  }

  function pushRowsToArray(array, rows) {
    rows.forEach((row) => {
      array.push(row)
    })
  }
  function sortRows(rows) {
    const sortedRows = []
    const firstItem = getFirstItem(rows)
    const contributorSubmitterIds = getContributorSubmitterIds(rows)
    const changeMessage = getChangeMessage(rows)
    const allOtherItems = getAllOtherItems(rows)
    pushRowsToArray(sortedRows, firstItem)
    pushRowsToArray(sortedRows, contributorSubmitterIds)
    pushRowsToArray(sortedRows, allOtherItems)
    pushRowsToArray(sortedRows, changeMessage)

    return sortedRows
  }

  function groupObjectsByChangeId(personChangesState) {
    const groupedObjects = {}
    personChangesState.changes.forEach((change) => {
      const commandUuid = change.rawPersonChange.commandUuid
      if (!groupedObjects[commandUuid]) {
        groupedObjects[commandUuid] = [change]
      } else {
        groupedObjects[commandUuid].push(change)
      }
    })
    return Object.values(groupedObjects)
  }

  return {
    sortRows,
    groupObjectsByChangeId,
  }
}
